export default {
  'menu.console.settings': '个人设置',
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.forgotPassword': '忘记密码',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.account.profile': '个人信息',


  'menu.admin.dashboard': '仪表盘',
  'menu.admin.dataScreen': '访问量统计分析',
  'menu.admin.settings': '系统配置',
  'menu.admin.providers': '模型供应商',
  'menu.admin.unbindDevice': '设备解绑',
  'menu.admin.userManage': '用户管理',
  'menu.admin.systemConfig': '高级配置',
  'menu.admin.distributedNodesConfig': '分布式节点配置',
  'menu.admin.whiteList': '白名单',
  'menu.admin.opsManage': '运维管理',
  'menu.admin.recorderManage': '录音管理',
  'menu.admin.deviceManage': '设备管理(旧)',
  'menu.admin.deviceBound': '设备管理',
  'menu.admin.hologramCover': '全息仓封面',
  'menu.console.hologramCover': '全息仓画面',
  'menu.console.hologram': '全息仓',
  'menu.console.hologram.cover': '更换封面',
  'menu.admin.agentsManage': '智能体',
  'menu.admin.adminKnowledgeBases': '知识库管理',
  'menu.admin.productManage': '产品管理',
  'menu.admin.productCategory': '产品分类',
  'menu.admin.roleTemplate': '角色模板',
  'menu.admin.rechargeManage': '流量卡充值',
  'menu.admin.orderLedger': '订单台账',
  'menu.admin.firmwarePackage': '固件包元数据',
  'menu.admin.feedbackManage': '问题反馈',
  'menu.admin.mcpToolGuard': 'MCP工具授权',
  'menu.admin.guardReport': '守护日报',
  'menu.admin.adminTodos': '待办事项管理',
  'menu.admin.adminLedger': '记账管理',
  'menu.admin.adminFriendTemplates': '好友预设模板',

  'menu.tenant': '企业管理',
  'menu.tenant.tenantDashboard': '企业数据看板',
  'menu.tenant.tenantInfo': '企业信息',
  'menu.tenant.tenantLicense': '设备授权',
  'menu.tenant.tenantSubAccount': '子企业管理',
  'menu.tenant.tenantDeviceBound': '设备管理',
  'menu.tenant.tenantProductionToken': '产线烧录 Token',
  'menu.tenant.tenantMcpEndpoint': '企业MCP接入点',
  'menu.tenant.tenantExtDb': '企业数据对接',
  'menu.tenant.tenantLocationConfig': '企业定位Key配置',
  'menu.tenant.tenantEnterpriseKnowledgeBases': '企业知识库',
  'menu.tenant.tenantTtsVoices': '企业音色管理',
  'menu.tenant.tenantProductCategory': '产品分类',
  'menu.tenant.tenantRoleTemplate': '角色模板',
  'menu.tenant.tenantFriendTemplates': '好友预设模板',

  'menu.console': '控制台',
  'menu.console.agents': '智能体',
  'menu.console.knowledgeBases': '知识库',
  'menu.console.agentDevice': '管理设备',
  'menu.console.devices': '设备管理',
  'menu.console.speakers': '声纹识别',
  'menu.console.voiceClone': '声音克隆',
  'menu.console.simRecharge': '4G 流量充值',
  'menu.console.developerGithub': '开发者认证',
  'menu.console.developerEnterprise': '企业认证',
  'menu.console.openapi': '开放平台',
  'menu.console.openapi.overview': '概览',
  'menu.console.openapi.apps': '应用与密钥',
  'menu.console.openapi.logs': '调用记录',
  'menu.console.mcpTutorial': 'MCP接入点教程',
  'menu.console.consoleTodos': '我的待办',
  'menu.console.consoleLedger': '我的记账',
  'menu.console.consoleFriends': '好友',
  'menu.console.consoleCallRecords': '陪聊通话记录',
  'menu.admin.openapiApps': '应用与密钥',
  'menu.admin.openapiPlanTiers': '套餐配置',
  'menu.admin.openapiUsageLogs': '调用审计',
  'menu.admin.openapiUsersUsage': '用户用量（限额与今日已用）',
  'menu.admin.openapiPartnerLinks': '外部用户映射',
  'menu.admin.enterpriseApplications': '企业认证审核',
};
